import React, { useEffect, useState } from "react";
import { getUserCredentials } from "../../../api/usuarioApi";
import { getAdminById } from "../../../api/AdminApi";
import Stock from "./Stock";
import "../opciones/Opciones.css";
import { canAccess, canDownloadExcel } from "../../../utils/permissions";

export default function Inventario() {
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  const [canExport, setCanExport] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        const admin = USERDATA?.[0];

        if (!admin) {
          setHasPermission(false);
          return;
        }

        setHasPermission(canAccess(admin, "inventario"));
        setCanExport(canDownloadExcel(admin));
      } catch (e) {
        console.error("Error al verificar permisos:", e);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: 38, height: 38, border: "4px solid #ddd", borderTop: "4px solid #1569c9ff", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }

  if (hasPermission !== true) return null;

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Stock de Inventario</h4>
      </div>
      <div className="card-body">
        <Stock canExport={canExport} />
      </div>
    </div>
  );
}
